import React from "react";
import PropTypes from "prop-types";
import { LogEvent } from "@learningblocks/shared-components";
import IconHexagon from "@learningblocks/exp-constants/lib/Icons/hexagon-solid";
import { NOTEBOOK } from "@learningblocks/exp-constants/lib/Utilities";
import "./style.scss";

export class SectionMenu extends React.Component {
  componentWillMount() {
    //console.log('selection specific section to go, to speed up dev');
    // this.props.goToSection('PROTOCOL');
    // this.props.goToSection('PREDICTIONS');
    // this.props.goToSection('MATERIALS');
    // this.props.goToSection('REFLECTION');
    // this.props.goToSection('RESULTS');
    // this.props.goToSection('SUMMARY');
  }
  wrapperClass() {
    const classList = [
      this.props.current ? "sections-list__itemActive" : "sections-list__item",
    ];
    return classList.join(" ");
  }
  menuArrow() {
    if (this.props.current && this.props.title !== NOTEBOOK.SECTION.DESIGN) {
      return <div className="section-arrow"></div>;
    } else {
      return null;
    }
  }
  goToSection = () => {
    if (this.props.current === false) {
      this.props.goToSection(this.props.value);
    }
    if (this.props.current && this.props.title === NOTEBOOK.SECTION.DESIGN) {
      this.props.goToFirstSection();
    }
  };
  render() {
    return (
      <li>
        <LogEvent
          logEventProps={{
            event_type: `sim_sidebar_${this.props.value.toLowerCase()}_btn clicked`,
            event_schema: "track",
          }}
          actionProps={{ onClick: { action: "click" } }}
          elementType="button"
        >
          <div
            style={{ width: "100%" }}
            className={this.wrapperClass()}
            role="button" // Adding role to indicate it's interactive
            tabIndex={0} // Making it focusable
            onClick={this.goToSection}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.goToSection();
              }
            }}
          >
            {this.menuArrow()}
            <div className="index">
              <span className="index-icon">
                <IconHexagon style={{ fill: "#003E6B" }} />
              </span>
              <span className="index-number">{this.props.number}</span>
            </div>
            <div className="title">{this.props.title}</div>
          </div>
        </LogEvent>
      </li>
    );
  }
}
SectionMenu.propTypes = {
  title: PropTypes.string.isRequired,
  current: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  goToSection: PropTypes.func.isRequired,
  goToFirstSection: PropTypes.func.isRequired,
};

SectionMenu.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  goToSection: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  goToFirstSection: () => {},
};
